import { Injectable } from '@angular/core';
import { FuseMockApiService } from '@fuse-inconcert/lib/mock-api';

@Injectable({ providedIn: 'root' })
export class AutoContactMockApi {
    private _contacts: any[] = [];
    private _batches: any[] = [];
    private _fieldMappings: any[] = [];

    constructor(private _fuseMockApiService: FuseMockApiService) {
        this.registerHandlers();
    }

    registerHandlers(): void {
        // Upload CSV
        this._fuseMockApiService.onPost('api/auto-contact/upload').reply(() => {
            const uploadId = Date.now().toString();
            return [200, { uploadId, message: 'CSV uploaded successfully' }];
        });

        // Get system fields
        this._fuseMockApiService.onGet('api/auto-contact/fields/system').reply(() => {
            return [200, [
                { id: 'name', label: 'Nombre', type: 'text', required: true },
                { id: 'phone', label: 'Teléfono', type: 'phone', required: true },
                { id: 'email', label: 'Email', type: 'email', required: false },
                { id: 'document', label: 'Documento', type: 'text', required: false }
            ]];
        });

        // Save field mapping
        this._fuseMockApiService.onPost('api/auto-contact/mapping').reply(({ request }) => {
            this._fieldMappings.push(request.body);
            return [200, { message: 'Mapping saved successfully' }];
        });

        // Get contacts
        this._fuseMockApiService.onGet('api/auto-contact/contacts').reply(() => {
            return [200, this._contacts];
        });

        // Create batch
        this._fuseMockApiService.onPost('api/auto-contact/api/batches').reply(({ request }) => {
            const batch = {
                id: Date.now().toString(),
                ...request.body,
                createdAt: new Date().toISOString()
            };
            this._batches.push(batch);
            return [200, batch];
        });

        // Get batches
        this._fuseMockApiService.onGet('api/auto-contact/api/batches').reply(() => {
            return [200, this._batches];
        });

        // Get outbound channels
        this._fuseMockApiService.onGet('api/auto-contact/channels/outbound').reply(() => {
            return [200, [
                { id: '1', name: 'Canal de Llamadas 1', type: 'call', outbound: true },
                { id: '2', name: 'Canal de Llamadas 2', type: 'call', outbound: true }
            ]];
        });
    }
}
